// extracted by mini-css-extract-plugin
export default {"container":"Landing_container__4K84n","centered":"Landing_centered__+vMpt","button":"Landing_button__aMdht"};